import { render, staticRenderFns } from "./FraudReceipts.vue?vue&type=template&id=72d1587a"
import script from "./FraudReceipts.vue?vue&type=script&lang=js"
export * from "./FraudReceipts.vue?vue&type=script&lang=js"
import style0 from "./FraudReceipts.vue?vue&type=style&index=0&id=72d1587a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports